import React from "react";
import { reduxForm } from "redux-form";
import {ff, form, HorizontalLoader} from "@mc/mc-legacy";
import { Button } from "reactstrap";
import UserAgreementFormSection from "./UserAgreementFormSection";
import { withLang } from "../../i18n/withLang";
import {i18n, i18nCustom} from "../../i18n/i18n";
import "./Form.scss";

const NewPassword = (props) => {
  const { handleSubmit, error, submitting, showAgreementForm } = props;
  const passwordComplexityDescription = i18nCustom(props.lang, "password_complexity.description", false);

  return (
    <form.Form className={"form"} horiznotal onSubmit={handleSubmit}>
      <form.FormBody>
        {error && <form.ValidationErrors error={error} />}
        <ff.String
          autoComplete={"off"}
          className={"py-15"}
          label={false}
          placeholder={i18n(props.lang, "NewPasswordForm_newPassword")}
          name={"newPassword"}
          type={"password"}
          required
          disabled={submitting}
        />
        <ff.String
          autoComplete={"off"}
          className={"py-15"}
          label={false}
          placeholder={i18n(props.lang, "NewPasswordForm_newPassword_repeat")}
          name={"newPassword_repeat"}
          type={"password"}
          required
          disabled={submitting}
        />
          {showAgreementForm && <div className={"pl-3"}><UserAgreementFormSection submitting={submitting} /></div>}
          {passwordComplexityDescription && <p>{passwordComplexityDescription}</p>}
      </form.FormBody>
      <form.FormActions submitButton={false} >
        <Button className={"py-15"} color={"primary"} disabled={submitting}>
            {i18n(props.lang, "NewPasswordForm_button_nastavitHeslo")}
        </Button>
      </form.FormActions>
    </form.Form>
  );
};

NewPassword.validate = (data, props) => {
  const errors = {};

  if (props.showAgreementForm) {
    if (!data.agreement) {
      errors.agreement = i18n(props.lang, "Form_agreement_required");
    }
  }

  if (!data.newPassword) {
    errors.newPassword = i18n(props.lang, "NewPasswordForm_newPassword_required");
  }

  if (!data.newPassword_repeat) {
    errors.newPassword_repeat = i18n(props.lang, "NewPasswordForm_newPassword_repeat_required");
  }

  return errors;
};

const NewPasswordForm = reduxForm({
  form: "newPassword",
  validate: NewPassword.validate,
})(NewPassword);
export default withLang(NewPasswordForm);
